import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSuccessDossier = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 132,
	height: 100,
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 71.133,
			cy: 95.334,
			fill: "#D9D9D9",
			rx: 60.867,
			ry: 4.4
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#0070BA",
			d: "M113.389 34.815H30.094v60.5h83.295v-60.5ZM82.428 28.547h30.923l.006 6.264H80.66l1.768-6.264Z"
		}),
		/* @__PURE__ */ _jsx("g", {
			fill: "#000",
			opacity: .2,
			children: /* @__PURE__ */ _jsx("path", { d: "M113.389 34.815H30.094v60.5h83.295v-60.5ZM82.427 28.547h30.923l.006 6.264H80.659l1.768-6.264Z" })
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#EBEBEB",
			d: "m63.82 40.405-22.029 4.138-5.314-28.282 16.356-3.07 6.681 4.317 4.306 22.897Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#DBDBDB",
			d: "m52.833 13.191 6.681 4.317-5.672 1.069-1.009-5.386ZM39.66 21.323l12.248-2.302-.136-.724-12.248 2.3.136.726ZM40 23.16l12.248-2.3-.136-.726-12.248 2.302.136.724ZM40.35 24.987 52.6 22.686l-.136-.725-12.249 2.3.136.726ZM40.698 26.817l17.946-3.372-.137-.725-17.946 3.372.137.725ZM41.038 28.649l17.946-3.372-.136-.725-17.946 3.372.136.725ZM41.383 30.48l17.946-3.37-.136-.726-17.946 3.372.136.725ZM41.729 32.323l17.946-3.372-.136-.725-17.946 3.372.136.725Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#0070BA",
			d: "m93.697 34.936-22.63-5.374L78.083 0l17.061 4.051 4.247 6.887-5.695 23.998Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "m93.697 34.936-22.63-5.374L78.083 0l17.061 4.051 4.247 6.887-5.695 23.998Z",
			opacity: .6
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#0070BA",
			d: "M99.391 10.938 93.827 9.62l1.318-5.57 4.246 6.888ZM80.844 11.662a1.735 1.735 0 1 0 2.083-1.296 1.725 1.725 0 0 0-2.083 1.296ZM81.668 19.772l11.443 2.717-4.062-8.346-7.381 5.629Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#0070BA",
			d: "m77.178 18.713 9.452 2.245-3.644-5.673-5.808 3.428Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#000",
			d: "m77.178 18.713 9.452 2.245-3.644-5.673-5.808 3.428Z",
			opacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#0070BA",
			d: "m93.518 23.156-16.99-4.035 2.9-12.234 17.008 4.024-2.918 12.245ZM77.834 18.32l14.876 3.53 2.403-10.125-14.876-3.53-2.403 10.125Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#EBEBEB",
			d: "M91.262 52.99 77.655 35.18l22.87-17.473 10.103 13.227-.857 7.918L91.262 52.99Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#DBDBDB",
			d: "m110.629 30.932-.857 7.918-3.503-4.589 4.36-3.33ZM97.415 22.824l7.566 9.903.587-.448-7.566-9.903-.587.448ZM95.93 23.956l7.566 9.903.586-.447-7.566-9.903-.586.447ZM94.449 25.09l7.566 9.902.586-.448-7.566-9.902-.586.447ZM92.972 26.227l11.086 14.51.586-.448-11.086-14.51-.586.448ZM91.49 27.355l11.085 14.51.586-.448-11.085-14.51-.586.448ZM90.003 28.486l11.086 14.51.586-.448-11.086-14.51-.586.448ZM88.523 29.62l11.085 14.509.586-.448-11.085-14.51-.586.448ZM87.044 30.752l11.086 14.51.586-.448-11.086-14.51-.586.448ZM85.563 31.879l11.085 14.51.587-.448-11.086-14.51-.586.448ZM84.078 33.014l11.085 14.51.586-.448-11.085-14.51-.587.448ZM82.599 34.148l11.086 14.51.586-.448L83.185 33.7l-.586.448ZM81.117 35.277l11.085 14.51.586-.448-11.085-14.51-.586.448Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#0070BA",
			d: "m57.08 51.406 28.14-8.774L73.958 6.508 53.06 13.02l-5.098 9.143 9.117 29.242Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "m57.08 51.406 28.14-8.774L73.958 6.508 53.06 13.02l-5.098 9.143 9.117 29.242Z",
			opacity: .4
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#0070BA",
			d: "m53.061 13.021-5.097 9.144 7.245-2.261-2.148-6.883Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "m73.401 14.366-15.646 4.876-.289-.927 15.647-4.876.288.927ZM74.131 16.704 58.484 21.58l-.288-.927 15.646-4.876.289.927ZM74.862 19.051l-15.647 4.877-.289-.927 15.647-4.876.289.926ZM75.595 21.394 52.67 28.539l-.289-.927 22.926-7.145.29.927ZM76.304 23.704l-22.925 7.15-.29-.927 22.926-7.15.289.927ZM77.054 26.068l-22.926 7.145-.289-.927 22.926-7.145.29.927ZM76.663 28.196 53.85 35.4l-.292-.922 22.814-7.204.29.922ZM77.386 30.556 54.573 37.76l-.291-.922 22.813-7.205.291.923ZM79.245 33.095 56.318 40.24l-.288-.927 22.926-7.145.289.927ZM79.974 35.439l-22.926 7.145-.289-.927 22.926-7.145.29.927ZM80.682 37.751l-22.925 7.15-.29-.927 22.926-7.15.289.927ZM81.413 40.09l-22.925 7.148-.289-.926 22.925-7.15.29.927Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#0070BA",
			d: "M30.066 95.313h83.29l10.407-55.479h-83.29L30.067 95.313ZM93.919 34.084h30.923l-1.079 5.748H91.066l2.853-5.748Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#20A76A",
			d: "M.118 64.408a20.958 20.958 0 0 0 35.02 13.257l10.49 1.534-5.245-9.063a20.968 20.968 0 0 0-25.869-27.88A20.97 20.97 0 0 0 .118 64.407Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#263238",
			d: "M6.392 47.098a20.927 20.927 0 0 1 17.559-5.835 21.197 21.197 0 0 1 16.808 29.035v-.365l5.223 9.085.386.676-.761-.118-10.48-1.609.247-.075a21.152 21.152 0 0 1-10.372 5.116c-.956.175-1.924.275-2.896.3-.971.07-1.946.07-2.918 0a20.84 20.84 0 0 1-5.641-1.35 20.38 20.38 0 0 1-5.052-2.811 23.085 23.085 0 0 1-2.22-1.877 21.684 21.684 0 0 1-1.9-2.145 21.076 21.076 0 0 1 2.05-27.888l-.033-.14ZM4.408 74.985a18.89 18.89 0 0 0 4.119 4.012 19.402 19.402 0 0 0 5.063 2.724c1.799.672 3.683 1.087 5.599 1.234.953.07 1.91.07 2.863 0a16.87 16.87 0 0 0 2.843-.344 20.573 20.573 0 0 0 10.04-5.17l.107-.096h.14l10.5 1.47-.376.557-5.277-9.053-.107-.171.075-.183a20.946 20.946 0 0 0 1.48-9.138 20.712 20.712 0 0 0-2.66-8.87 21.453 21.453 0 0 0-6.275-6.833 20.38 20.38 0 0 0-8.655-3.422 20.787 20.787 0 0 0-9.321.698A20.723 20.723 0 0 0 4.408 74.964v.021Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#EBF4EE",
			d: "M18.277 74.18 9.32 65.116l3.014-2.97 5.224 5.298L28.423 50.4l3.572 2.274L18.277 74.18Z"
		})
	]
});
const ForwardRef = forwardRef(SvgSuccessDossier);
export { ForwardRef as ReactComponent };
